<template>
  <div class="neu-card-ctn">
    <div class="neu-card mx-auto" style="justify-content:center;align-items:center">
      <base-icon :src="src" :color="iconColor || 'white'" fullWidth shadow></base-icon>
     <img style="width:60% !important" class="vertical img-icon icon-width" v-if="src == '/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png'" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"/>
    </div>
    <div class="subtitle mx-auto">
      <p v-html="paddedTitle"></p>
      <span v-html="paddedSubtitle">
      </span>
    </div>
  </div>
</template>
 
<script>
export default {
  name: 'neu-card',
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    subtitleLines: Number,
    titleLines: Number,
    iconColor: {
      type: String,
      required: false
    }
  },
  computed: {
    paddedTitle () {
      return this.titleLines ? `${this.title}${'<br>'.repeat(this.titleLines + 1)}` : this.title
    },
    paddedSubtitle () {
      return this.subtitleLines ? `${this.subtitle}${'<br>'.repeat(this.subtitleLines + 1)}` : this.subtitle
    }
  }
}
</script>

<style lang="scss" scoped>
.img-icon {
        margin: auto;
        float: left;
        &.vertical {
          height: 60%;
          @include mobile {
            height: 150px;
          }
        }
        &:not(.vertical) {
          width: 100px;
          @include mobile {
            width: 150px;
          }
        }

        object-fit: cover;
      }
.neu-card-ctn {
  .neu-card {
    display: flex;
    transition-duration: 1s;
 
    /* &:hover {
      @include desktop {
        padding: 4rem 6rem;
      }
      @include desktop-sm {
        padding: 0rem 4rem;
      }
      
      transition-duration: 1s;
    } */
    
    box-shadow: $custom-shadow;
    border: $border;
    border-radius: $border-radius;

    // Neu Icon vertically centered
    span {
      display: block;
    }
  }

  .subtitle  {
    text-align: left;

    @include desktop {
      margin-top: 4rem;
    }
    

    p {
      color: $blue;
      font-weight: bold;
      font-size: 1.25rem;
      white-space: normal;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/base/ui/NeuCard.vue